import { Alert } from "antd";
import { useEffect, useState } from "react";
import Loader from "src/components/loader.component";
const iconBg = {
    "darkblue": "lightblue",
    "darkpurple": "lightpurple",
    "darkgreen": "lightgreen",
    "grayishpurple": "lightgrey"
}
const AnalyticsKpi = ({ customClass, kpiDetails, loader }) => {
    const [data, setData] = useState([]);
    const isSeriesDataValid = (typeof kpiDetails === 'string' || !kpiDetails);
    useEffect(() => {
        setData(kpiDetails || [])
    }, [kpiDetails]);
    return <>
        {isSeriesDataValid && <Alert variant="danger" className='alert-flex' description={kpiDetails}
            showIcon>
            <p><span className="icon error-alert me-2"></span>{kpiDetails}</p>
        </Alert>}
        {loader && <div className="text-center"><Loader /></div>}
        {!isSeriesDataValid && data && !loader &&
            <div className={`grid ${customClass} mb-5 kpiCards`}>
                {data?.map(kpi => <div className="border-b border-b-light-secondaryColor dark:dark:border-b-dark-secondaryColor  py-2  analytics-card" key={kpi.name}>
                    <div className={`kpi-bg-${kpi.color} kpicard-style flex items-center px-4 py-2 space-x-2 border-r  border-r-light-secondaryColor dark:dark:border-r-dark-secondaryColor`}>
                        <span className={`icon ${kpi.name} `}></span>
                        <div className="">
                        <h3 className={`text-light-addonColor text-xl font-sans font-medium ${kpi?.balance?.toLocaleString().length > 12 && 'kpi-value-small'}`}>
                            {kpi.value ? kpi?.value?.toLocaleString() :
                                `$ ${kpi?.value?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`
                            }
                        </h3>
                        <p className="text-light-primaryColor text-xs font-sans font-normal mb-0.5">{kpi?.name}</p>
                        </div>
                    </div>
                </div>)}
            </div>
        }
    </>

}

export default AnalyticsKpi;